import { getCaseLockInfo, parseSafeInt } from "Backend";
import { LoaderFunctionArgs, redirect, ShouldRevalidateFunction } from "react-router-dom";
import { fetchCaseHome, resetCase } from "redux/slices/case";
import store from "redux/store";

export const caseLoader = async (args: LoaderFunctionArgs) => {
  // Safe Parse args.params.lensId and args.params.caseId to integers and save them to lensId and caseId
  // If either of them are not integers error out and redirect to /lens

  const caseId = parseSafeInt(args.params.caseId);
  const lensId = parseSafeInt(args.params.lensId);

  if (caseId === undefined || lensId === undefined) {
    return redirect("..");
  }

  store.dispatch(resetCase());

  try {
    const caseHome = await store.dispatch(fetchCaseHome({ caseId, lensId })).unwrap();
    if (getCaseLockInfo(caseHome.lens.customProperties.listCustomCaseProperties, caseHome.case.data).locked) {
      return redirect("..");
    }
    return caseHome;
  } catch (e) {
    console.error(e);
    return redirect("/lens");
  }
};

export const shouldRevalidateCase: ShouldRevalidateFunction = (params) => {
  const { currentParams, nextParams } = params;
  return currentParams.caseId !== nextParams.caseId;
};
